import { createSlice, createAction } from '@reduxjs/toolkit';
import { isRejectedAction } from 'redux/helpers';

import {
  LOGIN_ACTION,
  FORGOT_PASSWORD_ACTION,
  RESET_PASSWORD_ACTION,
} from '../auth/types';
import {
  NOTIFICATION,
  NOTIFICATION_SUCCESS_ACTION,
  NOTIFICATION_ERROR_ACTION,
  NOTIFICATION_DISMISS_ACTION,
  SUCCESS,
  ERROR,
} from './types';
import { isTest } from 'utils/environment';
import PATHS from 'routes/paths';

export const initialState = {
  isVisible: false,
  type: ERROR,
  message: 'An error occured',
  timeout: 5000,
};

export const dismiss = createAction(NOTIFICATION_DISMISS_ACTION);
export const showSuccessMessage = createAction(NOTIFICATION_SUCCESS_ACTION);
export const showErrorMessage = createAction(NOTIFICATION_ERROR_ACTION);

const notificationSlice = createSlice({
  name: NOTIFICATION,
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(dismiss, (state) => {
        return (state = initialState);
      })
      .addCase(showSuccessMessage, (state, { payload }) => {
        state.isVisible = true;
        state.type = SUCCESS;
        if (typeof payload === 'string') {
          state.message = payload;
        } else {
          if (payload.message) {
            state.message = payload.message;
          }
          if (payload.timeout) {
            state.timeout = payload.timeout;
          }
        }
      })
      .addCase(showErrorMessage, (state, { payload }) => {
        state.isVisible = true;
        state.type = ERROR;

        if (typeof payload === 'string') {
          state.message = payload;
        } else {
          if (payload.message) {
            state.message = payload.message;
          }
          if (payload.timeout) {
            state.timeout = payload.timeout;
          }
        }
      })
      .addMatcher(isRejectedAction, (state, { payload, type }) => {
        if (payload?.skipNotification) return;

        state.timeout = initialState.timeout;

        if (
          payload?.status > 400 &&
          [401, 404, 423, 500].indexOf(payload?.status) === -1
        ) {
          if (payload?.message) {
            state.isVisible = true;
            state.type = ERROR;
            state.message = payload.message;
          }
        } else if (
          payload?.status === 401 &&
          [PATHS.resetPassword, PATHS.forgotPassword, PATHS.login].indexOf(
            window.location.pathname
          ) === -1 &&
          [
            `${LOGIN_ACTION}/rejected`,
            `${FORGOT_PASSWORD_ACTION}/rejected`,
            `${RESET_PASSWORD_ACTION}/rejected`,
          ].indexOf(type) === -1 &&
          !isTest
        ) {
          //for every other response with 401 status
          state.isVisible = true;
          state.type = ERROR;
          state.message =
            'Your session has expired. Redirecting to login page...';
        }
      });
  },
});

export default notificationSlice.reducer;
